var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.toggleClick}},[_c('svg-icon',{staticClass:"side-trigger",class:{'is-collapse': _vm.isCollapse},attrs:{"icon-class":"menu"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }